import type { Action } from 'history';

import { Location } from '@cobliteam/common-types';

export interface LocationState {
  action: Action;
  location: {
    pathname: string;
    search: string;
    state: string;
    hash: string;
  };
}

export const locationInitialState: LocationState = {
  action: 'PUSH',
  location: {
    pathname: Location.MONITORING,
    search: '',
    state: '',
    hash: '',
  },
};
